module.exports = __webpack_public_path__ + "images/psp/College/planning.svg";